<template>
    <div>
        <vx-card no-shadow id="partner-details">

            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                <form @submit.prevent="handleSubmit(onClickUpdate)" autocomplete="off">
                    <div class="vx-row mb-3">
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider vid="email" name="email" rules="required" v-slot="{ errors }">
                                <small class="label">Email</small>
                                <vs-input v-model="partnerDetails.email" name="email" class="w-full required" label=""
                                    :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                    val-icon-pack="feather" />
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider vid="first_name" name="first_name" rules="required" v-slot="{ errors }">
                                <small class="label">First Name</small>
                                <vs-input v-model="partnerDetails.first_name" name="first_name" class="w-full required"
                                    label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                    val-icon-pack="feather" />
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider vid="last_name" name="last_name" rules="required" v-slot="{ errors }">
                                <small class="label">Last Name</small>
                                <vs-input v-model="partnerDetails.last_name" name="last_name" class="w-full required"
                                    label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                    val-icon-pack="feather" />
                            </ValidationProvider>
                        </div>
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider vid="company_name" name="company_name" rules="required"
                                v-slot="{ errors }">
                                <small class="label">Company Name</small>
                                <vs-input v-model="partnerDetails.company_name" name="company_name"
                                    class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]"
                                    val-icon-danger="icon-x" val-icon-pack="feather" />
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider vid="country" name="country" rules="required" v-slot="{ errors }">
                                <small class="label">Country</small>
                                <v-select :clearable="false" label="name" v-model="partnerDetails.country"
                                    :reduce="option => option.name" :options="countryCodes">
                                    <template v-slot:option="option">
                                        <span>{{ option.name }} </span>
                                    </template>
                                </v-select>
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider vid="start_date" name="start_date" rules="required" v-slot="{ errors }">
                                <small class="label">Account Handler</small>
                                <v-select :clearable="false" label="first_name"
                                    v-model="partnerDetails.account_handler_id" :reduce="option => option.id"
                                    :options="account_handlers">
                                    <template v-slot:option="option">
                                        <span>{{ option.first_name }} - {{ option.email }} </span>
                                    </template>
                                </v-select>
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col">
                            <ValidationProvider vid="comment" name="comment" rules="" v-slot="{ errors }">
                                <small class="label">Comments</small>
                                <vs-textarea class="mb-0" v-model="partnerDetails.comment" height="150px" />
                                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="flex flex-wrap items-center justify-end mt-8">
                        <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
                    </div>
                </form>
            </ValidationObserver>
        </vx-card>
    </div>
</template>
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const ChannelPartnerRepository = RepositoryFactory.get('channel_partner')
const CountryCodeRepository = RepositoryFactory.get('countryCode');
const UserRepository = RepositoryFactory.get('user');
import vSelect from 'vue-select'

export default {
    name: "ChanelPartnerProfileDetails",
    props: {
        tenant_id: {
            required: true,
            default: ''
        },
        partner_id: {
            required: true,
            default: ''
        }
    },
    components: {
        'v-select': vSelect,
    },
    data() {
        return {
            partnerDetails: {},
            countryCodes: [],
            account_handlers: []
        }
    },
    async mounted() {
        await this.loadCountryCodes()
        await this.fetchUsers()
        await this.fetchPartnerData()
    },
    methods: {
        async fetchPartnerData() {
            try {
                const { data } = (await ChannelPartnerRepository.getChannelPartner(this.partner_id)).data
                this.partnerDetails = data
            } catch (error) {

            }
        },
        async onClickUpdate() {
            await this.$vs.loading({
                container: '#partner-details',
                scale: 0.45
            })
            try {
                await ChannelPartnerRepository.updateChannelPartner(this.tenant_id, this.partner_id, this.partnerDetails)
            } catch (error) {

            } finally {
                this.$vs.loading.close('#partner-details > .con-vs-loading')
            }
        },
        async loadCountryCodes() {
            const { data } = await CountryCodeRepository.get()
            this.countryCodes = data.data
        },
        async fetchUsers() {
            const { data } = (await UserRepository.get(1, '', 150, '')).data
            this.account_handlers = data
        },
    }
}
</script>
<style lang="">

</style>